import { render, staticRenderFns } from "./FamilyPatients.vue?vue&type=template&id=59a93e86"
import script from "./FamilyPatients.vue?vue&type=script&lang=js"
export * from "./FamilyPatients.vue?vue&type=script&lang=js"
import style0 from "./FamilyPatients.vue?vue&type=style&index=0&id=59a93e86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports